'use client';

import React, { useState } from 'react';

interface CopyableCommandProps {
  command: string;
  label?: string;
}

export default function CopyableCommand({ command, label }: CopyableCommandProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="bg-gray-900 text-gray-100 p-4 rounded-lg shadow">
      {label && <p className="text-xs text-gray-400 mb-2 uppercase tracking-wide">{label}</p>}
      <div className="flex items-center justify-between gap-3">
        <code className="text-green-400 font-mono text-sm break-all">
          <span className="select-none text-gray-400 mr-2">$</span>
          {command}
        </code>
        <button
          onClick={handleCopy}
          aria-label={`Copy command: ${command}`}
          className="flex-shrink-0 text-gray-400 hover:text-white transition"
        >
          {copied ? (
            <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
